/**
 * 토큰 관리를 위한 싱글톤 클래스
 * 애플리케이션 전체에서 하나의 인스턴스만 사용
 * localStorage를 활용하여 새로고침/탭 이동에도 토큰이 유지되도록 개선
 */
class TokenStorage {
  private static instance: TokenStorage;

  private constructor() {}

  static getInstance(): TokenStorage {
    if (!TokenStorage.instance) {
      TokenStorage.instance = new TokenStorage();
    }
    return TokenStorage.instance;
  }

  setToken(token: string | null): void {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }
}

// 싱글톤 인스턴스 내보내기
export const tokenStorage: TokenStorage = TokenStorage.getInstance();

export default TokenStorage;
